import { theme } from '@bpba/ui-components';
import { useEffect, useState } from 'react';

export enum Breakpoints {
  MOBILE = -1,
  TABLET = 0,
  SMALL_DESKTOP = 1,
  DESKTOP = 2,
  LARGE_DESKTOP = 3,
}

export const useMinWidth = (query: Breakpoints) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(`(min-width: ${theme.breakpoints[query] ?? 0})`);

    if (media.matches !== matches) {
      setMatches(media.matches);
    }

    const listener = () => setMatches(media.matches);

    window.addEventListener('resize', listener);
    return () => window.removeEventListener('resize', listener);
  }, [matches, query]);

  return matches;
};
